import logosped from 'assets/images/logo-sped.jpg';

import DashboardMenu from './DashboardMenu';
import {
  LinkItem,
  LinksContainer,
  Logo,
  NavbarContainer,
  ToolbarContainer,
  WrapperContainer,
  WrapperLogo,
} from './Navbar.styles';
import RelatoriesMenu from './RelatoriesMenu';
import SettingsMenu from './SettingsMenu';
import UserMenu from './UserMenu';

interface NavbarProps {
  shouldShowSuperiorButtons: boolean;
}

const Navbar: React.FC<NavbarProps> = ({ shouldShowSuperiorButtons }) => {
  return (
    <NavbarContainer position="static" data-testid="navbar-component">
      <WrapperContainer>
        <ToolbarContainer>
          <WrapperLogo>
            <Logo src={logosped} alt="logo-sped" />
          </WrapperLogo>

          <LinksContainer>
            {shouldShowSuperiorButtons && (
              <>
                <DashboardMenu />

                <LinkItem
                  href={`${process.env.REACT_APP_GESTAO_BASE_URL}/main/notification-center`}
                >
                  Central de Notificações
                </LinkItem>

                <RelatoriesMenu />

                <SettingsMenu />

                <UserMenu />
              </>
            )}
          </LinksContainer>
        </ToolbarContainer>
      </WrapperContainer>
    </NavbarContainer>
  );
};

export default Navbar;
